module.exports = __webpack_public_path__ + "img/acco_search_header.70bcd56.jpg";